import { useMutation } from 'react-query';
import { lovageApi } from 'src/axios';

export interface BillingPortal {
  portal_url: string;
}

export const createBillingPortal = (data: {}) => {
  console.log('createBillingPortal');
  return lovageApi.post<BillingPortal>(`/dashboard/billing/portal`).then((res) => res.data);
};

export default function useCreateBillingPortal() {
  return useMutation(createBillingPortal);
}
